import { Wording } from '@/types';

export const COOKING_WORDING_RO: Wording = {
  components_header_media_content: 'Videoclipuri de gătit',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Rețete',
  components_header_text2: 'Blog',
  components_header_members: 'Membri',
  hero_text: 'Gătește cu pasiune, mănâncă cu bucurie',
  hero_button_text: 'Începeți să gătiți astăzi',
  components_ressources_section_title: 'RESURSE',
  components_ressources_subheader_text: 'Toate resursele de care ai nevoie pentru a învăța, a găti și a crea mâncare mai bună',
  components_ressources_span_text: 'Descoperiți o colecție bogată de rețete video, ghiduri culinare detaliate și perspective de specialitate despre asocierea aromelor, prezentarea mâncării și creativitatea culinară.',
  components_ressources_card_1_title: 'Inspirație culinară',
  components_ressources_card_1_text: 'Inspiră-te din rețete creative și videoclipuri culinare.',
  components_ressources_card_2_title: 'Cunoștințe culinare',
  components_ressources_card_2_text: 'Învață tehnici esențiale de gătit, combinații de arome și elemente de bază ale asocierii alimentelor prin intermediul unor ghiduri clare și practice.',
  components_ressources_link: 'Vizionați videoclipuri',
  components_notes_and_google_title_1: 'Educație culinară',
  components_notes_and_google_title_2: 'Gătit de zi cu zi',
  components_notes_and_google_title_3: 'Abilități culinare constante',
  components_review_google_text: 'Recenzii pe Google',
  media_content_section_title: 'Videoclipuri de gătit',
  media_content_section_subheader_text: 'Explorează rețete și videoclipuri cu instrucțiuni de gătit pas cu pas.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Mai multe videoclipuri',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Ghiduri și articole',
  text2_section_button_more: 'Mai multe articole',
  components_text1_section_title: 'REȚETE',
  components_text1_subheader_text: 'Rețete delicioase pentru gătitul de zi cu zi',
  components_text1_span_text: 'Descoperă rețete ușor de urmat, concepute pentru mesele de zi cu zi, cu pași clari și rezultate excelente.',
  components_text1_card_1_title: 'Începe-ți ziua cu dreptul',
  components_text1_card_1_text: 'Rețete simple și gustoase pentru a începe ziua cu savoare și ușurință.',
  components_text1_card_3_title: 'Idei de prânz savuroase',
  components_text1_card_3_text: 'Rețete delicioase pentru prânz, ușor de preparat și pline de savoare.',
  components_text1_card_2_title: 'Rețete reconfortante pentru cină',
  components_text1_card_2_text: 'Rețete calde și sățioase pentru cină, perfecte pentru seri relaxante acasă.',
  components_text1_link: 'Vezi toate rețetele',
  components_footer_text: 'Învață să gătești mai bine, creează mâncare mai bună: Bucătăria ta, călătoria ta.',
  components_footer_info: 'Informații',
  components_footer_registration_number: 'Număr de înmatriculare',
  components_footer_legal: 'Juridic',
  components_footer_terms: 'Termeni și condiții',
  components_footer_privacy: 'Politica de confidențialitate',
  button_load_more: 'Încărcați mai mult',
  page_media_1_content_hero_text: 'Descoperă videoclipuri culinare simple pentru toate gusturile',
  page_text1_hero_text: 'Rețete',
  page_text1_section_title: 'Sfaturi de gătit',
  page_text1_subheader_text: 'Rețete',
  page_text2_hero_text: 'Blogul nostru',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Ghiduri și articole',
  enter_email_title: 'Vă rugăm să introduceți adresa dvs. de e-mail pentru a continua',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Introduceți',
  components_login_success_text: 'Conectare reușită!',
  components_card_link_media_content: 'Urmărește acum',
  components_card_link_text1_content: 'Vezi rețeta',
  components_card_link_text2_content: 'Vizualizați articolul',
};